import { put } from "../../../../utils/api";
import GenericViewDrawer1 from "../../GenericViewDrawer1";

const ViewDetailsDrawerInHouseOffset = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const fields = [
    // {
    //   label: "Consumption Period",
    //   previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
    //   requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
    //     data?.editValue?.consumptionPeriod?.year || "—"
    //   }`,
    // },
    {
      label: "Project Name",
      previous: data?.projectName,
      requested: data?.editValue?.projectName,
    },
    {
      label: "Project Type",
      previous: data?.projectType,
      requested: data?.editValue?.projectType,
    },
    {
      label: "Project Location",
      previous: data?.projectLocation ? 
        `${data.projectLocation.city}, ${data.projectLocation.state}, ${data.projectLocation.country}` : "—",
      requested: data?.editValue?.projectLocation ? 
        `${data.editValue.projectLocation.city}, ${data.editValue.projectLocation.state}, ${data.editValue.projectLocation.country}` : "—",
    },
    {
      label: "Verification Status",
      previous: data?.verificationStatus,
      requested: data?.editValue?.verificationStatus,
    },
    {
      label: "Carbon Sequestered Annually (tCO₂e)",
      previous: data?.carbonSequesteredAnnually,
      requested: data?.editValue?.carbonSequesteredAnnually,
    },
    {
      label: "Methodology Used",
      previous: data?.methodologyUsed,
      requested: data?.editValue?.methodologyUsed,
    },
    // {
    //   label: "Total Emission",
    //   previous: data?.totalEmision,
    //   requested: data?.editValue?.totalEmision || "—",
    // },
    {
      label: "Remarks",
      previous: data?.remarks,
      requested: data?.editValue?.remarks,
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="In-House Offset Project Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default ViewDetailsDrawerInHouseOffset;
